import styled, { css } from 'styled-components'
import { generateMedia } from 'styled-media-query'

type WrapperProps = {
  hasTestInput?: boolean
  hasNotArrowNumber?: boolean
}
const media = generateMedia({
  xs: '400px',
  sm: '550px',
  md: '768px',
  lg: '1200px',
})
export const Wrapper = styled.div<WrapperProps>`
  ${({ theme, hasTestInput, hasNotArrowNumber }) => css`
    width: 100%;

    input {
      border: 1px solid ${theme.colors.lightGray};
      display: block;
      width: 100%;
      height: 48px;
      font-size: 1rem;
      padding: 0.6rem;
      border-radius: ${theme.border.xradius};
      background: ${theme.colors.white};
      transition: 0.2s;

      &:disabled {
        cursor: not-allowed;
        color: ${theme.colors.gray};

        &:hover {
          border-color: ${theme.colors.lightGray};
          background: none;
          box-shadow: none;
        }
      }

      &:hover {
        outline: none;
        border-color: ${theme.colors.secondary};
        box-shadow: 0 0 0 3px rgba(0, 0, 0, 0.1);
      }

      ${hasTestInput
      && css`
        height: 50px;
        background: ${theme.colors.xxlightGray};

        &::placeholder {
          color: ${theme.colors.black};
        }
      `}
    }

    ${hasNotArrowNumber
    && css`
      input::-webkit-outer-spin-button,
      input::-webkit-inner-spin-button {
        -webkit-appearance: none;
        margin: 0;
      }

      input[type='number'] {
        -moz-appearance: textfield;
      }
    `}

    label {
      display: block;
      margin-top: 1rem;
      margin-left: 6px;
      padding-bottom: 0.3rem;
      font-family: 'Montserrat';
      font-style: normal;
      font-weight: 600;
      --BaseFontSize: 17px;
      --BaselineHeight: 17px;
      line-height: var(--BaselineHeight);
      font-size: var(--BaseFontSize);
      ${media.between('sm', 'md')`
      font-size: calc(var(--BaseFontSize) / 1,1625);
      line-height: calc(var(--BaselineHeight) 1,1625);
      `}
      ${media.between('xs', 'sm')`
      font-size: calc(var(--BaseFontSize) 1.781);
      line-height: calc(var(--BaselineHeight) 1.781);
      `}
      ${media.lessThan('xs')`
      font-size: calc(var(--BaseFontSize)/2.028);
      line-height: calc(var(--BaselineHeight)/2.028);
      `}
    }

    .error {
      color: ${theme.colors.red};
      font-size: ${theme.font.sizes.xxxsmall};
      font-weight: ${theme.font.bold};
      margin: 0px 0 4px 6px;
    }
  `}
`
